import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {AgentsService} from "../../../agents/services/agents-service.service";
import {AgentDialogService} from "../../../agents/services/agent-dialogs-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {ScheduleDialogService} from "../../services/schedule-dialog.service";
import {ScheduleService} from "../../services/schedule-service.service";
import {AgentModel} from "../../../agents/angular/models/agent.model";

export class ScheduleApprovalTableComponent implements IController {
  agents: AgentModel[];
  schedules: any;
  onApprove: Function;
  onReject: Function;

  public agentsMap: {[key: string]: AgentModel};

  constructor() {

  }

  $onInit() {
    this._setAgentsMap(this.agents);
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.agents && !changes.agents.isFirstChange()) {
      this._setAgentsMap(this.agents);
    }
  }

  private _setAgentsMap(agents: AgentModel[]) {
    this.agentsMap = {};
    _.forEach(agents, (a) => {
      this.agentsMap[a.id] = a;
    });
  }

}

angular
  .module('bringoz.admin.schedule')
  .component('scheduleApprovalTable', {
    bindings: {
      agents: '<',
      schedules: '<',
      onApprove: '&',
      onReject: '&'
    },
    templateUrl: 'app/modules/schedule/components/schedule-approval-table/schedule-approval-table.html',
    controller: ScheduleApprovalTableComponent
  });
